// Format any number as a percent
export function formatPercent(number, decimals, showPercent) {
    return (
        number !== null ? parseFloat(number * 100).toFixed(decimals) + (showPercent ? '%' : '') : '-'
    )
}

// Format any number
export function formatNumber(number, decimals) {
    return (
        number !== null ? parseFloat(number).toFixed(decimals) : '-'
    )
}

// Format any date
export function formatDate(dateString) {
    return (
        dateString && (new Date(dateString)).toLocaleDateString(undefined,
            {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }
        )
    )
}

// Format any time
export function formatTime(dateString) {
    return (
        dateString && (new Date(dateString)).toLocaleTimeString(undefined,
            {
                hour: '2-digit',
                minute: '2-digit'
            }
        )
    )
}

// Get a dictionary of the key metrics formatted correctly
export function getKeyMetrics(statistics){
    return ({
        performance: formatPercent(statistics.stdPerformanceMonthlyCommonPeriodNAV, 2, false),
        income: formatPercent(statistics.dividendYield, 1, false), 
        risk: formatPercent(statistics.avgAnnualVolatility, 1, false), 
        sharpe: formatNumber(statistics.sharpeRatio, 2),
        fees: formatNumber(statistics.aggregateExpenseRatio * 10000, 0),
    })
}

// Get a dictionary of the key metrics' symbols 
export function getKeyMetricsSymbols(){

    return ({
        performance: '%',
        income: '%', 
        risk: '%', 
        sharpe: '',
        fees: 'bps',
    })
}

// Get a dictionary of which metrics are clickable (have their own charts)
export function getKeyMetricsClicks(){

    return ({
        performance: true,
        income: true, 
        risk: false, 
        sharpe: false,
        fees: false,
    })
}
